export default "__VITE_ASSET__HXW7OUTS__"